import React from "react";
import {
  EXPIRED_PREMIUM,
  FREE,
  NEAR_ENDING_PREMIUM,
  PREMIUM
} from "../../../../../constants/premiumState";
import {
  PURCHASE_TYPE,
  PURCHASE_USED_KEY,
  PURCHASE_STEPS_TYPE
} from "../../../../../constants/purchase";
import { Link } from "react-router-dom";

export default ({ premium_state, volume_size_remain, image_count_remain }) => {
  const link = "صفحه تنظیمات پروژه";
  const noticeMessage = (keyWord1, keyword2) => (
    <React.Fragment>
      سقف
      {keyWord1}
      برای بارگذاری تصویر به پایان رسیده‌است. با
      {keyword2}
      می‌توانید تصاویر بیشتری را پیوست نمایید. همچنین برای مشاهده جزئیات پروژه و
      حجم‌ مصرفی به
      <Link to="/project-setting"> {link} </Link>
      مراجعه کنید.
    </React.Fragment>
  );
  let action = "";

  switch (premium_state) {
    case FREE:
      action = (
        <Link
          to={{
            pathname: "/purchase",
            state: {
              [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CHOOSE_PLAN,
              [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.NEW
            }
          }}
        >
          {" "}
          خرید اشتراک{" "}
        </Link>
      );
      break;
    case PREMIUM:
      action = (
        <span>
          <Link
            to={{
              pathname: "/purchase",
              state: {
                [PURCHASE_USED_KEY.FORM_STEP]:
                  PURCHASE_STEPS_TYPE.CHOOSE_PLAN_OPTIONS,
                [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.UPGRADE
              }
            }}
          >
            {" "}
            ارتفا امکانات{" "}
          </Link>
        </span>
      );
      break;
    case EXPIRED_PREMIUM:
      action = (
        <span>
          <Link
            to={{
              pathname: "/purchase",
              state: {
                [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CHOOSE_PLAN,
                [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.NEW
              }
            }}
          >
            {" "}
            تمدید اشتراک{" "}
          </Link>
          خود{" "}
        </span>
      );
      break;
    case NEAR_ENDING_PREMIUM:
      action = (
        <span>
          <Link
            to={{
              pathname: "/purchase",
              state: {
                [PURCHASE_USED_KEY.FORM_STEP]:
                  PURCHASE_STEPS_TYPE.CHOOSE_PLAN_OPTIONS,
                [PURCHASE_USED_KEY.PURCHASE_ACTION]: PURCHASE_TYPE.UPGRADE
              }
            }}
          >
            {" "}
            ارتفا امکانات{" "}
          </Link>
        </span>
      );

      break;
  }
  if (volume_size_remain <= 0) {
    return noticeMessage(" فضای اختصاصی شما  ", action);
  } else if (
    (premium_state === FREE || premium_state === EXPIRED_PREMIUM) &&
    image_count_remain <= 0
  ) {
    return noticeMessage(" تعداد مجاز ", action);
  }
};
